/* @ngInject */

export default (
  $rootScope,
  helperService,
  helperPdfService,
  supportingCommentaryPdfService,
  Address,
  INSTANCE
) => {
  /**
   * Prepare business details.
   *
   * @param {Array} lenders
   * @param {Array} contacts
   * @param {Array} contactLabels
   * @param {Object} ticketOwner
   * @param {Object} preferredProduct
   * @param {Object} loan
   * @param {Object} workflow
   * @param {String} date
   *
   * @returns {Array}
   */
  const prepareBusinessDetails = ({
    lenders,
    contacts,
    contactLabels,
    ticket,
    ticketOwner,
    preferredProduct,
    loan,
    workflow,
    date
  }) => {
    const content = [];
    if (ticketOwner && preferredProduct) {
      let idLender = '';
      if (workflow.isAssetFinance()) {
        idLender = preferredProduct?.selectedProduct?.lender[0]?.id;
      }
      if (workflow.isHomeLoan()) {
        idLender = preferredProduct?.idLender;
      }
      const brokerPrimary = _.find(
        ticketOwner.lenderAccreditations,
        (l) => l.idLender === idLender
      );
      content.push({
        text: '',
        margin: [0, 20, 0, 0]
      });
      let headerTitle = 'APPLICATION FORM';
      if (
        workflow?.isHomeLoan() &&
        helperService.getOrganizationCountry().cca2 === 'AU' &&
        (INSTANCE.identification === 'VOW' ||
          INSTANCE.identification === 'YNT' ||
          INSTANCE.identification === 'DEV')
      ) {
        headerTitle = 'APPLICATION SUMMARY';
      }
      content.push(
        helperPdfService.createHeader({
          title: headerTitle
        })
      );
      content.push({
        text: `Prepared on: ${date}`,
        style: ['prepared']
      });
      content.push({
        text: '',
        margin: [0, 10, 0, 0]
      });
      content.push(
        helperPdfService.createSubHeader({
          title: 'INTRODUCER DETAILS'
        })
      );
      content.push({
        table: {
          widths: ['25%', '25%', '25%', '25%'],
          body: [
            [
              {
                text: [
                  {
                    text: 'Full name\n',
                    style: 'label'
                  },
                  {
                    text: ticketOwner.getName(),
                    style: 'value'
                  }
                ]
              },
              {
                text: [
                  { text: 'Introducer ID\n', style: 'label' },
                  {
                    text: brokerPrimary?.brokerIdPrimary || '-',
                    style: 'value'
                  }
                ]
              },
              {
                text: [
                  { text: 'Mobile phone\n', style: 'label' },
                  {
                    text: `${ticketOwner?.user?.phone ? ticketOwner?.user?.prefix : ''} ${
                      ticketOwner?.user?.phone || '-'
                    }`,
                    style: 'value'
                  }
                ]
              },
              {
                text: [
                  { text: 'Fixed phone\n', style: 'label' },
                  {
                    text: `${
                      ticketOwner?.user?.fixedPhone ? ticketOwner?.user?.fixedPrefix : ''
                    } ${ticketOwner?.user?.fixedPhone || '-'}`,
                    style: 'value'
                  }
                ]
              }
            ],
            [
              {
                text: [
                  { text: 'E-Mail\n', style: 'label' },
                  {
                    text: ticketOwner?.user?.eMail || '-',
                    style: 'value'
                  }
                ],
                colSpan: 2
              },
              '',
              idLender === '42a574159c95d014b3c7c7dd1da8d9ee'
                ? {
                  text: [
                    { text: 'Source of business number\n', style: 'label' },
                    {
                      text: preferredProduct?.sourceOfBusinessNumber || '-',
                      style: 'value'
                    }
                  ]
                }
                : '',
              ''
            ]
          ]
        },
        layout: 'noBorders'
      });

      content.push(
        helperPdfService.createSubHeader({
          title: 'INTRODUCER BUSINESS DETAILS'
        })
      );
      content.push({
        table: {
          widths: ['25%', '25%', '25%', '25%'],
          body: [
            [
              {
                text: [
                  {
                    text: 'Organization name\n',
                    style: 'label'
                  },
                  {
                    text: $rootScope.CurrentOrganization.getName(),
                    style: 'value'
                  }
                ]
              },
              {
                text: [
                  { text: 'Organization address\n', style: 'label' },
                  {
                    text: Address.getAddress(
                      $rootScope.CurrentOrganization?.organization?.address
                    ),
                    style: 'value'
                  }
                ],
                colSpan: helperService.getOrganizationCountry().cca2 !== 'NZ' ? 2 : 3
              },
              '',
              ''
            ]
          ]
        },
        layout: 'noBorders'
      });
      if (helperService.getOrganizationCountry().cca2 !== 'NZ') {
        content[content.length - 1].table.body[0][3] = {
          text: [
            {
              text: 'Credit licence number\n',
              style: 'label'
            },
            {
              text: $rootScope.CurrentOrganization?.organization?.licenses?.id1 || '-',
              style: 'value'
            }
          ]
        };
      }

      // Applicants
      if (contacts && ticket) {
        content.push(
          helperPdfService.createSubHeader({
            title: 'APPLICANTS'
          })
        );
        let body = 0;
        const len = contacts?.length || 0;
        if (len) {
          content.push({
            table: {
              widths: ['45.5%', '8%', '45.5%'],
              body: []
            },
            layout: 'noBorders'
          });
        }
        for (let c = 0; c < len; c += 1) {
          const contact = contacts[c];
          const contactType = helperService.getContactTypeInDeal({
            ticket,
            contactLabels,
            idContact: contact.id
          });
          if (c % 2 === 0) {
            content[content.length - 1].table.body.push(['', '', ''], ['', '', '']);
            content[content.length - 1].table.body[body][0] = {
              text: [
                {
                  text: `${contactType}\n`,
                  style: 'label'
                },
                {
                  text: contact.getName(),
                  style: 'value'
                }
              ],
              border: [false, false, false, true]
            };
          } else {
            content[content.length - 1].table.body[body][2] = {
              text: [
                {
                  text: `${contactType}\n`,
                  style: 'label'
                },
                {
                  text: contact.getName(),
                  style: 'value'
                }
              ],
              border: [false, false, false, true]
            };
            body += 1;
          }
        }

        if (
          workflow?.isAssetFinance() &&
          helperService.getOrganizationCountry().cca2 === 'AU' &&
          ticket?.otherAdvisers?.length
        ) {
          const cLen = contacts?.length || 0;
          for (let c = 0; c < cLen; c += 1) {
            const contact = contacts[c];
            const contactType = helperService.getContactTypeInDeal({
              ticket,
              contactLabels,
              idContact: contact.id
            });
            if (contactType === 'Borrower') {
              const otherAdvisersByContact = _.filter(
                ticket?.otherAdvisers,
                (obj) =>
                  (obj.isOtherAdviserAccountantType() ||
                    obj.isOtherAdviserPrimaryBankerType()) &&
                  obj.idContacts.indexOf(contact.id) > -1
              );
              if (otherAdvisersByContact.length) {
                let accountantCount = 0;
                let primaryBankerCount = 0;
                const oLen = otherAdvisersByContact.length;
                for (let o = 0; o < oLen; o += 1) {
                  const otherAdviser = otherAdvisersByContact[o];
                  if (otherAdviser.isOtherAdviserAccountantType()) {
                    accountantCount += 1;
                    content.push(
                      helperPdfService.createSubHeader({
                        title: `${otherAdviser.otherAdviserType.title.toUpperCase()} #${accountantCount} - ${contact.getName()}`
                      })
                    );
                    content.push({
                      table: {
                        widths: ['25%', '25%', '25%', '25%'],
                        body: [
                          [
                            {
                              text: [
                                { text: 'Firm\n', style: 'label' },
                                {
                                  text: otherAdviser?.companyName || '-',
                                  style: 'value'
                                }
                              ]
                            },
                            {
                              text: [
                                { text: 'Contact person (first name)\n', style: 'label' },
                                {
                                  text: otherAdviser?.contactFirstName || '-',
                                  style: 'value'
                                }
                              ]
                            },
                            {
                              text: [
                                { text: 'Contact person (surname)\n', style: 'label' },
                                {
                                  text: otherAdviser?.contactLastName || '-',
                                  style: 'value'
                                }
                              ]
                            },
                            ''
                          ]
                        ]
                      },
                      layout: 'noBorders'
                    });
                  }
                  if (otherAdviser.isOtherAdviserPrimaryBankerType()) {
                    primaryBankerCount += 1;
                    content.push(
                      helperPdfService.createSubHeader({
                        title: `${otherAdviser.otherAdviserType.title.toUpperCase()} #${primaryBankerCount} - ${contact.getName()}`
                      })
                    );
                    content.push({
                      table: {
                        widths: ['25%', '25%', '25%', '25%'],
                        body: [
                          [
                            {
                              text: [
                                { text: 'Bank\n', style: 'label' },
                                {
                                  text: otherAdviser?.companyName || '-',
                                  style: 'value'
                                }
                              ]
                            },
                            {
                              text: [
                                { text: 'Branch\n', style: 'label' },
                                {
                                  text: otherAdviser?.bankBranch || '-',
                                  style: 'value'
                                }
                              ]
                            },
                            {
                              text: [
                                { text: 'Contact person (first name)\n', style: 'label' },
                                {
                                  text: otherAdviser?.contactFirstName || '-',
                                  style: 'value'
                                }
                              ]
                            },
                            {
                              text: [
                                { text: 'Contact person (surname)\n', style: 'label' },
                                {
                                  text: otherAdviser?.contactLastName || '-',
                                  style: 'value'
                                }
                              ]
                            }
                          ]
                        ]
                      },
                      layout: 'noBorders'
                    });
                  }
                }
              }
            }
          }
        }
      }

      // Structure summary
      if (loan) {
        if (
          workflow?.isAssetFinance() &&
          loan?.assetDetails?.length &&
          helperService.getOrganizationCountry().cca2 !== 'AU'
        ) {
          content.push(
            helperPdfService.createSubHeader({
              title: 'STRUCTURE SUMMARY'
            })
          );
          const len = loan?.assetDetails?.length;
          content.push({
            table: {
              widths: ['25%', '25%', '25%', '25%'],
              body: [['', '', '', '']]
            },
            layout: 'noBorders'
          });
          let hLBody = 0;
          for (let a = 0; a < len; a += 1) {
            const asset = loan?.assetDetails[a];
            content[content.length - 1].table.body[hLBody][0] = {
              text: [
                { text: 'Asset model\n', style: 'label' },
                {
                  text: asset?.vehicle?.model || '-',
                  style: 'value'
                }
              ],
              colSpan: 3
            };
            content[content.length - 1].table.body[hLBody][3] = {
              text: [
                { text: 'Asset cost\n', style: 'label' },
                {
                  text: helperService
                    .isNumber(asset?.cost, true)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ]
            };
            hLBody += 1;
          }
          content.push({
            table: {
              widths: ['25%', '25%', '25%', '25%'],
              body: [
                [
                  {
                    text: [
                      { text: 'Lender\n', style: 'label' },
                      {
                        text: helperService.getLenderByContentType({
                          lenders,
                          lenderId: preferredProduct?.selectedProduct?.lender[0]?.id,
                          contentType: 'id'
                        }),
                        style: 'value'
                      }
                    ],
                    colSpan: 2
                  },
                  '',
                  {
                    text: [
                      { text: 'LVR/LVT\n', style: 'label' },
                      {
                        text: `${loan?.financeProposal?.lvr.toFixed(2)}%`,
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Net amount financed\n', style: 'label' },
                      {
                        text: loan?.financeProposal?.netAmountFinanced.formatWithCurrency(
                          $rootScope.CurrentCurrency(),
                          0
                        ),
                        style: 'value'
                      }
                    ]
                  }
                ]
              ]
            },
            layout: 'noBorders'
          });
        }
        if (workflow?.isHomeLoan() && loan?.securityDetails?.securitySplits?.length) {
          content.push(
            helperPdfService.createSubHeader({
              title: 'STRUCTURE SUMMARY'
            })
          );
          const len = loan?.securityDetails?.securitySplits?.length;
          content.push({
            table: {
              widths: ['25%', '25%', '25%', '25%'],
              body: []
            },
            layout: 'noBorders'
          });
          let hLBody = 0;
          for (let s = 0; s < len; s += 1) {
            content[content.length - 1].table.body.push(['', '', '', '']);
            const security = loan?.securityDetails?.securitySplits[s];
            content[content.length - 1].table.body[hLBody][0] = {
              text: [
                { text: 'Address\n', style: 'label' },
                {
                  text: Address.getAddress(security?.address),
                  style: 'value'
                }
              ],
              colSpan: 3
            };
            content[content.length - 1].table.body[hLBody][3] = {
              text: [
                { text: 'Security value\n', style: 'label' },
                {
                  text: helperService
                    .isNumber(security?.value, true)
                    .formatWithCurrency($rootScope.CurrentCurrency(), 0),
                  style: 'value'
                }
              ]
            };
            hLBody += 1;
          }
          let lvr = 0;
          if (!_.isEmpty(loan?.fundingWorksheets)) {
            const maxLVR = _.max(_.map(loan?.fundingWorksheets?.fundsAvailable, 'baseLvr'));
            lvr = maxLVR || 0;
          }
          content.push({
            table: {
              widths: ['25%', '25%', '25%', '25%'],
              body: [
                [
                  {
                    text: [
                      { text: 'Lender\n', style: 'label' },
                      {
                        text: helperService.getLenderByContentType({
                          lenders,
                          lenderId: preferredProduct?.idLender,
                          contentType: 'id'
                        }),
                        style: 'value'
                      }
                    ],
                    colSpan: 2
                  },
                  '',
                  {
                    text: [
                      { text: 'LVR\n', style: 'label' },
                      {
                        text: `${lvr.toFixed(2)}%`,
                        style: 'value'
                      }
                    ]
                  },
                  {
                    text: [
                      { text: 'Loan amount\n', style: 'label' },
                      {
                        text: _.reduce(
                          preferredProduct?.productSplits,
                          (memo, num) =>
                            memo + helperService.isNumber(num.totalLoanAmount, true),
                          0
                        ).formatWithCurrency($rootScope.CurrentCurrency(), 0),
                        style: 'value'
                      }
                    ]
                  }
                ]
              ]
            },
            layout: 'noBorders'
          });
        }
      }
    }
    return content;
  };

  return {
    prepareBusinessDetails
  };
};
